'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _nl = require('moment/locale/nl');

var _nl2 = _interopRequireDefault(_nl);

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

TelefoonService.$inject = ['TelefoonConstants', 'EnvironmentService', '$http', '$q', '$log'];


var _module = _angular2.default.module('cb.telefoon.service', []);

_module.factory('TelefoonService', TelefoonService);

exports.default = _module;


function TelefoonService(TelefoonConstants, EnvironmentService, $http, $q, $log) {

    var telefoonResource;
    var contactResource = EnvironmentService.isSitecore() ? TelefoonConstants.CONTACT_RESOURCE_SITECORE : TelefoonConstants.CONTACT_RESOURCE_SHAREPOINT;
    var service = {
        getPhoneNumber: getPhoneNumber,
        getSchedule: getSchedule,
        getOpenTime: getOpenTime,
        getKeuzemenu: getKeuzemenu
    };

    return service;

    /**
     * Get contact resource data
     *
     * @returns {*}
     */
    function getTelefoonResource() {
        if (!telefoonResource) {
            telefoonResource = $q.defer();
            $http.get(contactResource).success(function (data) {
                telefoonResource.resolve(data);
            }).error(function () {
                $log.warn('TelefoonService: Could not retrieve contact data');
                telefoonResource.reject('TelefoonService: Could not retrieve contact data');
            });
        }
        return telefoonResource.promise;
    }

    /**
     * Get contact phoneNumber
     *
     * @param product
     * @returns {deferred.promise|{then, catch, finally}}
     */
    function getPhoneNumber(product) {
        var deferred = $q.defer();

        getTelefoonResource().then(function (data) {
            if (_angular2.default.isObject(data.contact[product]) && _angular2.default.isDefined(data.contact[product].telefoonnummer)) {
                deferred.resolve(data.contact[product].telefoonnummer);
            } else {
                deferred.reject('TelefoonService: Could not retrieve ' + product + ' data');
            }
        }, function () {
            deferred.reject('TelefoonService: Could not retrieve ' + product + ' data');
        });

        return deferred.promise;
    }

    /**
     * Get schedule for product or default schedule when product is undefined
     *
     * @param product
     * @returns {deferred.promise|{then, catch, finally}}
     */
    function getSchedule(product) {
        var deferred = $q.defer();

        getTelefoonResource().then(function (data) {
            var scheduleName = TelefoonConstants.DEFAULT_SCHEDULE;
            var schedules = {};

            // schedules can be comma separated, put them in separated hash
            _angular2.default.forEach(data.openingstijden, function (schedule, key) {
                var items = key.split(',');
                for (var i = 0; i < items.length; i++) {
                    schedules[items[i]] = schedule;
                }
            });

            if (_angular2.default.isDefined(product)) {
                // if a product is provided check if product exists else reject
                if (_angular2.default.isObject(data.contact[product])) {
                    // keep default is no custom openingstijden exists
                    if (_angular2.default.isDefined(schedules[product])) {
                        scheduleName = product;
                    }
                } else {
                    deferred.reject('TelefoonService: Could not retrieve ' + product + ' data');
                }
            }

            if (_angular2.default.isObject(schedules[scheduleName])) {

                var schedule = schedules[scheduleName];

                schedule.feestdagen = _angular2.default.isDefined(data.feestdagen) ? data.feestdagen : [];
                schedule.vaste_feestdagen = _angular2.default.isDefined(data.vaste_feestdagen) ? data.vaste_feestdagen : [];

                deferred.resolve(schedule);
            } else {
                deferred.reject('TelefoonService: Could not retrieve openingstijden "' + scheduleName + '"');
            }
        }, function () {
            deferred.reject('TelefoonService: Could not retrieve ' + product + ' data');
        });

        return deferred.promise;
    }

    /**
     * Get the next best open time for product.
     *
     * @param product
     * @returns {deferred.promise|{then, catch, finally}}
     */
    function getOpenTime(product) {
        var deferred = $q.defer();
        var date = (0, _moment2.default)();

        getSchedule(product).then(function (schedule) {
            var isOpen = isOpenOnDate(schedule, date);

            // when not open now try next 7 days
            var count = 1;
            while (!isOpen && count < 7) {
                date.add(1, 'd');
                isOpen = isOpenOnDate(schedule, date, count);
                if (isOpen) {
                    if (count === 1) {
                        isOpen.type = 'morgen';
                    } else {
                        isOpen.type = 'later';
                        isOpen.dag = date.format('dddd');
                    }
                }
                count++;
            }

            if (isOpen) {
                isOpen.message = getContactMessage(isOpen.type, isOpen);
                deferred.resolve(isOpen);
            } else {
                deferred.reject('TelefoonService: Could not find next best opening date for ' + product);
            }
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

    /**
     * Check datetime to schedule if it is now or later today.
     * Returns opening hours object when open and false when not open today.
     *
     * @param schedule
     * @param date
     * @returns {boolean}
     */
    function isOpenOnDate(schedule, date, daycounter) {

        var dayMonthYear = date.format('D-M-YYYY');
        var dayMonth = date.format('D-M');
        var fullDay = date.format('dddd').toLowerCase();
        var year = date.format('YYYY');
        var hollidays = [];

        var currentHours = schedule[dayMonthYear] || schedule[dayMonth] || schedule[fullDay];
        var isOpen = false;

        if (_angular2.default.isDefined(schedule['vaste_feestdagen']) && _angular2.default.isArray(schedule['vaste_feestdagen'])) {
            _angular2.default.forEach(schedule['vaste_feestdagen'], function (item) {
                hollidays.push(item);
            });
        }

        if (_angular2.default.isDefined(schedule['feestdagen'][year]) && _angular2.default.isArray(schedule['feestdagen'][year])) {
            _angular2.default.forEach(schedule['feestdagen'][year], function (item) {
                hollidays.push(item);
            });
        }

        if (_angular2.default.isDefined(currentHours) && hollidays.indexOf(dayMonth) === -1) {
            var openTime = getMomentTime(currentHours.open, date);
            var closeTime = getMomentTime(currentHours.gesloten, date);

            if (date < openTime) {
                isOpen = _angular2.default.extend({
                    datum: date,
                    type: 'straks'
                }, currentHours);
            } else if (date > openTime && date < closeTime) {
                isOpen = _angular2.default.extend({
                    datum: date,
                    type: 'nu'
                }, currentHours);
            } else if (daycounter > 0) {
                //if not today, don't check hours but only if currentHours exists (meaning it's open on the specified day)
                isOpen = _angular2.default.extend({
                    datum: date,
                    type: 'later'
                }, currentHours);
            }
        }

        return isOpen;
    }

    /**
     * Returns moment object with set time
     *
     * @param time
     * @param date
     * @returns {*}
     */
    function getMomentTime(time, date) {
        date = date || (0, _moment2.default)();
        time = time || '0.00';

        var r = time.indexOf('.') > -1 ? time.split('.') : time.indexOf(':') ? time.split(':') : [0, 0];

        return (0, _moment2.default)(date).hour(r[0]).minute(r[1]);
    }

    function getContactMessage(type, variables) {
        var text = _angular2.default.isDefined(TelefoonConstants.MESSAGES[type]) ? TelefoonConstants.MESSAGES[type] : '';

        _angular2.default.forEach(variables, function (value, key) {
            text = text.replace('{' + key + '}', value);
        });

        return text;
    }

    /**
     * Get contact keuzemenu
     *
     * @param product
     * @returns {deferred.promise|{then, catch, finally}}
     */
    function getKeuzemenu(product) {
        var deferred = $q.defer();

        getTelefoonResource().then(function (data) {
            if (_angular2.default.isObject(data.contact[product]) && _angular2.default.isDefined(data.contact[product].telefoonnummer) && _angular2.default.isDefined(data.keuzemenu[data.contact[product].telefoonnummer])) {
                deferred.resolve(data.keuzemenu[data.contact[product].telefoonnummer]);
            } else {
                deferred.reject('TelefoonService: Could not retrieve ' + product + ' data');
            }
        }, function () {
            deferred.reject('TelefoonService: Could not retrieve ' + product + ' data');
        });

        return deferred.promise;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/telefoon/telefoon.service.js
// module id = 827
// module chunks = 0